import { useParams as useParamsRRD } from 'react-router-dom';

export function useParams<Params extends { [K in keyof Params]?: string }>() {
	return useParamsRRD<Params>();
}
